import {Router} from '@angular/router';
import {Component, Input, OnInit, OnChanges, SimpleChanges} from '@angular/core';
import {FavoriteService} from 'src/app/services/favorite.service';
import {AuthService} from 'src/app/services/auth.service';
import {ProductModel} from 'src/app/models/wardrobe.model';
import {PaginatedResponse} from './../../models/paginated-response.model';
import {Config} from 'src/app/config';
import {Platform, ActionSheetController, ToastController} from '@ionic/angular';
import {marker} from '@biesbjerg/ngx-translate-extract-marker';
import {TranslateService} from '@ngx-translate/core';
import {config} from 'rxjs';

// import { SocialSharing } from '@awesome-cordova-plugins/social-sharing/ngx';

@Component({
  selector: 'shc-wardrobe-item-v2',
  templateUrl: './wardrobe-item-v2.component.html',
  styleUrls: ['./wardrobe-item-v2.component.scss'],
})
export class WardrobeItemV2Component implements OnInit, OnChanges {
  @Input() searchText?: string;
  @Input() products: PaginatedResponse<ProductModel>;

  constructor(private router: Router,
              protected translate: TranslateService,
              private platform: Platform,
              private actionSheetCtrl: ActionSheetController,
              private toastCtrl: ToastController,
              private favoriteService: FavoriteService,
              private authService: AuthService,
  ) {
  }

  ngOnInit() {
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.products && this.products?.data?.length) {
      this.authService.loggedIn.subscribe((loggedIn) => {
        if (loggedIn) {
          this.applyFavorites();
        }
      });
    }
  }

  applyFavorites() {
    this.favoriteService.favoritesList().subscribe(
      (res) => {
        const favoritedIds = new Set(res.data.map((p) => p.id));
        this.products.data.forEach((product) => {
          product.favorited = favoritedIds.has(product.id);
        });
      },
      (error) => {
        console.error('Kon favorieten niet ophalen:', error);
      },
    );
  }

  toggleFavorite(product: ProductModel, event: Event) {
    event.stopPropagation();
    const previousValue = product.favorited;
    product.favorited = !previousValue;
    this.favoriteService.toggleFavorite(product.id).subscribe(
      (res) => {
        product.favorited = res.favorited;
      },
      (error) => {
        product.favorited = previousValue;
        console.error('Favoriet wijzigen mislukt:', error);
      },
    );
  }

  dropdownProductId2: number | null = null;

  isIOS(): boolean {
    return this.platform.is('ios');
  }

  isAndroid(): boolean {
    return this.platform.is('android');
  }

  toggleDropdown(productId: number) {
    if (this.isIOS()) {
      return; // Don't show custom dropdown on iOS
    }
    this.dropdownProductId2 = this.dropdownProductId2 === productId ? null : productId;
  }

  async createBranchLink(branchData: any): Promise<string> {
    try {
      const Branch = window['Branch'];

      if (!Branch) {
        return `${Config.siteUrl}/product/${branchData.productId}`;
      }

      // Only canonicalIdentifier is required
      const properties = {
        canonicalIdentifier: `swopster/product/${branchData.productId}`,
        title: branchData.title,
        contentDescription: branchData.text,
        contentImageUrl: branchData.contentImageUrl,
        contentMetadata: {
          customData: {productId: branchData.productId}
        }
      };

      console.log({properties});

      // Create Branch Universal Object
      const branchUniversalObj = await Branch.createBranchUniversalObject(properties);
      console.log('BUO created:', branchUniversalObj);

      // Generate short URL
      const shortUrlResponse = await branchUniversalObj.generateShortUrl({}, {});
      console.log('Branch short URL:', shortUrlResponse.url);

      return shortUrlResponse.url;

    } catch (err) {
      console.error('Branch link error:', err);
      // Fallback URL
      return `${Config.siteUrl}/product/${branchData.productId}`;
    }
  }

  private async copyToClipboard(text: string): Promise<boolean> {
    try {
      if (navigator.clipboard && typeof navigator.clipboard.writeText === 'function') {
        await navigator.clipboard.writeText(text);
      } else {
        // Fallback for older browsers/webviews
        const textarea = document.createElement('textarea');
        textarea.value = text;
        document.body.appendChild(textarea);
        textarea.select();
        document.execCommand('copy');
        document.body.removeChild(textarea);
      }
      return true;
    } catch (err) {
      console.error('Failed to copy:', err);
      return false;
    }
  }

  async openShareOptions(product: ProductModel) {
    // const text = `this.translate.instant(marker('Product.LinkTitle')): ${product.title}`;
    const text = `${this.translate.instant(marker('Product.LinkTitle'))}: ${product.title}`;

    // const url = `${Config.siteUrl}/product/${product.id}`; // Default
    // const subject = 'Awesome Product';
    const subject = product.title || this.translate.instant(marker('Product.LinkTitle'));
    const wardrobeObj = {
      title: subject,
      contentImageUrl: product?.images?.length
        ? product?.images[0]?.url
        : 'https://ionicframework.com/docs/demos/api/avatar/avatar.svg',
      productId: product.id,
      text
    };

    console.log({wardrobeObj});

    const url = await this.createBranchLink(wardrobeObj); // Returning branch.io short link

    console.log({url}, 'branch short url');

    const canUseNavigatorShare =
      typeof navigator !== 'undefined' &&
      typeof navigator.share === 'function' &&
      window.isSecureContext;

    // ✅ iOS: Use only Web Share API
    if (this.isIOS() && canUseNavigatorShare) {
      try {
        await navigator.share({
          title: subject,
          text,
          url,
        });
        return;
      } catch (err) {
        console.warn('Web Share API canceled:', err);
        return; // no fallback for iOS
      }
    }

    // ✅ Android & other fallback: full share Action Sheet
    const actionSheet = await this.actionSheetCtrl.create({
      header: this.translate.instant('Buttons.ShareVia'),
      cssClass: 'custom-share-sheet',
      buttons: [
        {
          text: 'WhatsApp',
          icon: 'logo-whatsapp',
          cssClass: 'whatsapp-share',
          handler: () => {
            window.open(`https://api.whatsapp.com/send?text=${encodeURIComponent(text + ' ' + url)}`, '_system');
          },
        },
        {
          text: 'Facebook',
          icon: 'logo-facebook',
          cssClass: 'facebook-share',
          handler: () => {
            window.open(`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`, '_system');
          },
        },
        {
          text: 'Twitter',
          icon: 'logo-twitter',
          cssClass: 'twitter-share',
          handler: () => {
            window.open(`https://twitter.com/intent/tweet?text=${encodeURIComponent(text)}&url=${encodeURIComponent(url)}`, '_system');
          },
        },
        {
          text: 'LinkedIn',
          icon: 'logo-linkedin',
          cssClass: 'linkedin-share',
          handler: () => {
            window.open(`https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(url)}&text=${encodeURIComponent(text)}`, '_system');
          },
        },
        {
          text: 'Telegram',
          icon: 'paper-plane-outline',
          cssClass: 'telegram-share',
          handler: () => {
            window.open(`https://t.me/share/url?url=${encodeURIComponent(url)}&text=${encodeURIComponent(text)}`, '_system');
          },
        },
        {
          text: 'Email',
          icon: 'mail-outline',
          cssClass: 'email-share',
          handler: () => {
            window.location.href = `mailto:?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(text + '\n' + url)}`;
          },
        },
        {
          text: this.translate.instant('Buttons.CopyLink'),
          icon: 'link-outline',
          handler: async () => {
            const copied = await this.copyToClipboard(url);
            if (copied) {
              const toast = await this.toastCtrl.create({
                message: this.translate.instant('Toast.copySuccess'), // Todo: Translate it
                duration: 2000,
                position: 'bottom',
              });
              await toast.present();
            }
          },
        },
        {
          text: this.translate.instant('Buttons.Cancel'),
          icon: 'close',
          role: 'cancel',
          cssClass: 'ion-button theme-btn-alt as-ion-button',
        },
      ],
    });

    await actionSheet.present();
  }


// isIOS(): boolean {
//     return this.platform.is('ios') ||
//            /iPad|iPhone|iPod/.test(navigator.userAgent) ||
//            (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
//   }

//   isAndroid(): boolean {
//     return this.platform.is('android') ||
//            /Android/.test(navigator.userAgent);
//   }

//   isMobile(): boolean {
//     return this.isIOS() || this.isAndroid();
//   }

//   async openShareOptions(product: ProductModel) {
//     const text = `Check out this product: ${product.title}`;
//     const url = `${Config.siteUrl}/product/${product.id}`;
//     const subject = 'Awesome Product';

//     // Try Web Share API first if available
//     if (this.canUseWebShare()) {
//       try {
//         await navigator.share({
//           title: subject,
//           text: text,
//           url: url
//         });
//         return;
//       } catch (err) {
//         console.log('Web Share API canceled or failed:', err);
//         // Continue to fallback options
//       }
//     }

//     // For mobile devices
//     if (this.isMobile()) {
//       await this.showMobileShareSheet(text, url, subject);
//     }
//     // For desktop browsers
//     else {
//       await this.showDesktopShareOptions(text, url);
//     }
//   }

//   private canUseWebShare(): boolean {
//     return typeof navigator !== 'undefined' &&
//            typeof navigator.share === 'function' &&
//            window.isSecureContext;
//   }

//   private async showMobileShareSheet(text: string, url: string, subject: string) {
//     const actionSheet = await this.actionSheetCtrl.create({
//       header: 'Share via',
//       cssClass: 'custom-share-sheet',
//       buttons: [
//         {
//           text: 'WhatsApp',
//           icon: 'logo-whatsapp',
//           handler: () => {
//             this.shareToWhatsApp(text, url);
//           }
//         },
//         {
//           text: 'Facebook',
//           icon: 'logo-facebook',
//           handler: () => {
//             this.shareToFacebook(url);
//           }
//         },
//         {
//           text: 'LinkedIn',
//           icon: 'logo-linkedin',
//           handler: () => {
//             this.shareToLinkedIn(url);
//           }
//         },
//         {
//           text: 'Twitter',
//           icon: 'logo-twitter',
//           handler: () => {
//             this.shareToTwitter(text, url);
//           }
//         },
//         {
//           text: 'Telegram',
//           icon: 'paper-plane-outline',
//           handler: () => {
//             this.shareToTelegram(text, url);
//           }
//         },
//         {
//           text: 'Email',
//           icon: 'mail-outline',
//           handler: () => {
//             this.shareViaEmail(text, url, subject);
//           }
//         },
//         {
//           text: 'Copy Link',
//           icon: 'copy-outline',
//           handler: () => {
//             this.copyToClipboard(`${text} - ${url}`);
//           }
//         },
//         {
//           text: 'Cancel',
//           icon: 'close',
//           role: 'cancel'
//         }
//       ]
//     });

//     await actionSheet.present();
//   }

//   private async showDesktopShareOptions(text: string, url: string) {
//     try {
//       await this.copyToClipboard(`${text} - ${url}`);
//       this.showToast('Link copied to clipboard!');
//     } catch (err) {
//       console.error('Failed to copy:', err);
//       this.showToast('Please copy the link manually');
//     }
//   }

//   private shareToWhatsApp(text: string, url: string) {
//     const shareUrl = `https://api.whatsapp.com/send?text=${encodeURIComponent(text + ' ' + url)}`;
//     this.openNewWindow(shareUrl);
//   }

//   // private shareToFacebook(url: string) {
//   //   const shareUrl = Config.facebookAppId
//   //     ? `https://www.facebook.com/dialog/share?app_id=${Config.facebookAppId}&display=popup&href=${encodeURIComponent(url)}&redirect_uri=${encodeURIComponent(url)}`
//   //     : `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`;

//   //   this.openNewWindow(shareUrl, 600, 400);
//   // }
//   private shareToFacebook(url: string) {
//   if (this.isMobile()) {
//     const fbScheme = this.isIOS()
//       ? `fb://facewebmodal/f?href=${encodeURIComponent(url)}`
//       : `fb://faceweb/f?href=${encodeURIComponent(url)}`;

//     // Try to open the app directly
//     window.location.href = fbScheme;

//     // Fallback to browser after short delay
//     setTimeout(() => {
//       const webShareUrl = Config.facebookAppId
//         ? `https://www.facebook.com/dialog/share?app_id=${Config.facebookAppId}&display=popup&href=${encodeURIComponent(url)}&redirect_uri=${encodeURIComponent(url)}`
//         : `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`;
//       window.open(webShareUrl, '_blank');
//     }, 1200);
//   } else {
//     // Desktop fallback
//     const webShareUrl = Config.facebookAppId
//       ? `https://www.facebook.com/dialog/share?app_id=${Config.facebookAppId}&display=popup&href=${encodeURIComponent(url)}&redirect_uri=${encodeURIComponent(url)}`
//       : `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`;
//     this.openNewWindow(webShareUrl, 600, 400);
//   }
// }

//   // private shareToLinkedIn(url: string) {
//   //   const shareUrl = `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(url)}`;
//   //   this.openNewWindow(shareUrl);
//   // }
//   private shareToLinkedIn(url: string) {
//   if (this.isMobile()) {
//     const liScheme = `linkedin://shareArticle?mini=true&url=${encodeURIComponent(url)}`;
//     window.location.href = liScheme;

//     setTimeout(() => {
//       const webShareUrl = `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(url)}`;
//       window.open(webShareUrl, '_blank');
//     }, 1200);
//   } else {
//     const webShareUrl = `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(url)}`;
//     this.openNewWindow(webShareUrl, 600, 400);
//   }
// }

//   private shareToTwitter(text: string, url: string) {
//     const shareUrl = `https://twitter.com/intent/tweet?text=${encodeURIComponent(text)}&url=${encodeURIComponent(url)}`;
//     this.openNewWindow(shareUrl);
//   }

//   private shareToTelegram(text: string, url: string) {
//     const shareUrl = `https://t.me/share/url?url=${encodeURIComponent(url)}&text=${encodeURIComponent(text)}`;
//     this.openNewWindow(shareUrl);
//   }

//   private shareViaEmail(text: string, url: string, subject: string) {
//     const mailtoUrl = `mailto:?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(text + '\n' + url)}`;
//     window.location.href = mailtoUrl;
//   }

//   private async copyToClipboard(text: string) {
//     try {
//       if (navigator.clipboard) {
//         await navigator.clipboard.writeText(text);
//       } else {
//         // Fallback for older browsers
//         const textarea = document.createElement('textarea');
//         textarea.value = text;
//         document.body.appendChild(textarea);
//         textarea.select();
//         document.execCommand('copy');
//         document.body.removeChild(textarea);
//       }
//       return true;
//     } catch (err) {
//       console.error('Failed to copy:', err);
//       return false;
//     }
//   }

//   private openNewWindow(url: string, width = 600, height = 600) {
//     const left = (screen.width - width) / 2;
//     const top = (screen.height - height) / 2;
//     const target = this.platform.is('cordova') ? '_system' : '_blank';
//     window.open(url, target, `width=${width},height=${height},top=${top},left=${left}`);
//   }

//   private showToast(message: string) {
//     // Implement using ToastController or your preferred method
//     console.log(message); // Temporary fallback
//   }

}
